import { z } from "zod";
const SUPPORTED_CURRENCIES = ["GBP"];
export const Currency = z.enum(SUPPORTED_CURRENCIES);
export const Money = z.object({
    amountMinor: z.number().int(),
    currency: Currency,
});
const MAJOR_DIVISOR = {
    GBP: 100,
};
const SYMBOL = {
    GBP: "£",
};
export function formatMoney(money) {
    const divisor = MAJOR_DIVISOR[money.currency];
    const major = money.amountMinor / divisor;
    const formatted = major.toLocaleString("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return `${SYMBOL[money.currency]}${formatted}`;
}
export function addMoney(a, b) {
    if (a.currency !== b.currency) {
        throw new Error(`Cannot add money of different currencies: ${a.currency} + ${b.currency}`);
    }
    return { amountMinor: a.amountMinor + b.amountMinor, currency: a.currency };
}
